jQuery(document).ready(function() {
	$('.button').each(function(){
    	$(this).wrapInner('<span></span>');
	});
	$('.filter-bar button.facetwp-reset').each(function(){
    	$(this).wrapInner('<span></span>');
	});
});